export const USER_LOGIN = 'USER_LOGIN';
export const login = () => ({
  type: USER_LOGIN,
});

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const loginSuccess = (user, token, role) => ({
  type: LOGIN_SUCCESS,
  user,
  token,
  role,
});

export const LOGIN_ERROR = 'LOGIN_ERROR';
export const loginError = (message, status) => ({
  type: LOGIN_ERROR,
  message,
  status,
});

export const RESET_LOGIN = 'RESET_LOGIN';
export const resetLogin = () => ({
  type: RESET_LOGIN,
});

export const FIRST_LOGIN = 'FIRST_LOGIN';
export const firstLogin = (isFirstLogin, token, user, role) => ({
  type: FIRST_LOGIN,
  isFirstLogin,
  token,
  user,
  role,
});

export const UPDATE_USER = 'UPDATE_USER';
export const updateUser = (user) => ({ type: UPDATE_USER, user });
